module.exports = __webpack_public_path__ + "img/taizhou-gao.ac41f3e7.png";